var ccUrl=(window.CB_CFG&&window.CB_CFG.ccUrl!==undefined)?window.CB_CFG.ccUrl:('');
var CC_URL=ccUrl;
function ccFilters(open){
  var sb=document.getElementById('cc-sidebar'),ov=document.getElementById('cc-overlay');
  if(!sb||!ov)return;
  if(open){sb.classList.add('cc-sidebar--open');ov.classList.add('cc-overlay--on');document.body.style.overflow='hidden';}
  else{sb.classList.remove('cc-sidebar--open');ov.classList.remove('cc-overlay--on');document.body.style.overflow='';}
}
function ccAtc(id,btn){
  var s=btn.querySelector('span');var orig=s.textContent;
  btn.disabled=true;s.textContent='...';
  fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:id,quantity:1})})
  .then(function(r){if(r.ok){s.textContent='✓';window.location.href='/cart';}else{s.textContent=orig;btn.disabled=false}})
  .catch(function(){s.textContent=orig;btn.disabled=false});
}
document.addEventListener('keydown',function(e){if(e.key==='Escape')ccFilters(false);});

/* Filtres & tri en AJAX : met à jour la grille + la barre latérale sans recharger la page. */
(function(){
  var busy=false;
  function ccNavigate(url,push){
    var main=document.querySelector('.cc-main');
    if(!main||busy){window.location.href=url;return;}
    busy=true;main.classList.add('is-loading');
    fetch(url,{headers:{'X-Requested-With':'XMLHttpRequest'}}).then(function(r){return r.text();}).then(function(html){
      var doc=new DOMParser().parseFromString(html,'text/html');
      var nm=doc.querySelector('.cc-main');
      if(!nm){window.location.href=url;return;}
      document.querySelector('.cc-main').replaceWith(nm);
      var ns=doc.getElementById('cc-sidebar'),cs=document.getElementById('cc-sidebar');
      if(ns&&cs){var wasOpen=cs.classList.contains('cc-sidebar--open');cs.replaceWith(ns);if(wasOpen)ns.classList.add('cc-sidebar--open');}
      if(push!==false)history.pushState({},'',url);
      busy=false;
      var top=document.querySelector('.cc-container');
      if(top){var y=top.getBoundingClientRect().top+window.pageYOffset-80;if(window.pageYOffset>y)window.scrollTo({top:y,behavior:'smooth'});}
    }).catch(function(){window.location.href=url;});
  }
  window.ccSort=function(val){
    var u=new URL(window.location.href);
    if(val==='manual'){u.searchParams.delete('sort_by');}else{u.searchParams.set('sort_by',val);}
    u.searchParams.delete('page');
    ccNavigate(u.pathname+u.search,true);
  };
  window.ccApply=function(){
    var form=document.getElementById('cc-ffilter');if(!form)return;
    var qs=[];
    new FormData(form).forEach(function(val,key){if(val!==''&&val!=null)qs.push(encodeURIComponent(key)+'='+encodeURIComponent(val));});
    ccNavigate(CC_URL+(qs.length?'?'+qs.join('&'):''),true);
  };
  document.addEventListener('submit',function(e){
    if(e.target&&e.target.id==='cc-ffilter'){e.preventDefault();window.ccApply();}
  });
  document.addEventListener('click',function(e){
    var a=e.target.closest('a');if(!a)return;
    if(a.closest('.cc-pag')||a.classList.contains('cc-achip')||a.classList.contains('cc-clear')){
      var href=a.getAttribute('href');if(!href)return;
      e.preventDefault();ccNavigate(href,true);
    }
  });
  window.addEventListener('popstate',function(){ccNavigate(location.pathname+location.search,false);});
})();
